import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import AtsChecker from './pages/AtsChecker';
import AtsResult from './pages/AtsResult';
import JdMatchInput from './pages/JdMatchInput';
import JdMatchResult from './pages/JdMatchResult';
import EmailGen from './pages/EmailGen';
import EmailResult from './pages/EmailResult';
import Profile from './pages/Profile';
import BulletFixer from './pages/BulletFixer';
import History from './pages/History';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <div className="bg-gray-50 min-h-screen font-sans text-gray-900">
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        <Route path="/tools/ats" element={<ProtectedRoute><AtsChecker /></ProtectedRoute>} />
        <Route path="/tools/ats/result" element={<ProtectedRoute><AtsResult /></ProtectedRoute>} />

        <Route 
          path="/tools/scanner" 
          element={
            <ProtectedRoute>
              <JdMatchInput />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/tools/jd-match" 
          element={
            <ProtectedRoute>
              <JdMatchInput />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/tools/scanner/result" 
          element={
            <ProtectedRoute>
              <JdMatchResult />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/tools/jd-match/result" 
          element={
            <ProtectedRoute>
              <JdMatchResult />
            </ProtectedRoute>
          } 
        />
        

        <Route path="/tools/email" element={<ProtectedRoute><EmailGen /></ProtectedRoute>} />
        <Route path="/tools/email/result" element={<ProtectedRoute><EmailResult /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/tools/fixer" element={<ProtectedRoute><BulletFixer /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
